import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate"
import { categoryModule } from "./categoryModule"
import { configModule } from "./configModule"
import { productModule } from "./productModule"
import { formModule } from "./formModule"
import { searchModule } from "./searchModule"
import { componentModule } from "./componentModule"
import { pageModule } from "./pageModule"



export default createStore({
  plugins: [createPersistedState()],
  modules: {
    category: categoryModule,
    config: configModule,
    product: productModule,
    form: formModule,
    search: searchModule,
    component: componentModule,
    page: pageModule
  }
})
